import { BufferTargetType, BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { GPUEngineStatisticsInfo } from "../../../RenderEngine/RenderEnum/RenderStatInfo";
import { UniformBufferManager } from "../../DriverDesign/RenderDevice/UniformBufferManager/UniformBufferManager";
export class WebGLUniformBufferManager extends UniformBufferManager {
    constructor(engine, offsetAlignment) {
        super(true);
        this.engine = engine;
        this.byteAlign = offsetAlignment;
        engine.on("endFrame", this, this.endFrame);
        engine.on("startFrame", this, this.startFrame);
    }
    createGPUBuffer(size, name) {
        let buffer = this.engine.createBuffer(BufferTargetType.UNIFORM_BUFFER, BufferUsage.Dynamic);
        buffer.bindBuffer();
        buffer.setDataLength(size);
        return buffer;
    }
    writeBuffer(buffer, data, offset, size) {
        buffer.bindBuffer();
        let gl = this.engine.gl;
        gl.bufferSubData(buffer._glTarget, offset, new Float32Array(data, offset, size / 4));
    }
    statisGPUMemory(bytes) {
        this.engine._addStatisticsInfo(GPUEngineStatisticsInfo.M_GPUMemory, bytes);
        this.engine._addStatisticsInfo(GPUEngineStatisticsInfo.M_GPUBuffer, bytes);
    }
    statisUpload(count, bytes) {
        this.engine._addStatisticsInfo(GPUEngineStatisticsInfo.C_UniformBufferUploadCount, count);
    }
}
